import Vue from "vue";
import register from "@/components/RegisterDialog.vue"; // 引入弹窗组件

const RegisterDialog = Vue.extend(register);

register.install = function(code, addr, base58Addr) {
    let locale = 'en_US';
    if (localStorage.getItem('language')) {
    locale = localStorage.getItem('language');
    } else if (['en_US', 'zh_HK', 'es_ES', 'tr_TR', 'en_XA', 'pt_PT', 'de_DE', 'fr_FR', 'ja_JP', 'ko_KR', 'it', 'ru'].includes(navigator.language)) {
    locale = navigator.language;
    }
  let instance = new RegisterDialog({
    i18n: { // `i18n` 选项，为组件设置语言环境信息
        locale,
        messages: {
            en_US: {
                bind_inviter: 'Bind inviter',
                Please_enter_the_invitation_code: 'Please enter the invitation code',
                confirm: 'Confirm',
                select_Network: 'Select network',
            },
            zh_HK: {
                bind_inviter: '绑定邀请人',
                Please_enter_the_invitation_code: '请输入邀请码',
                confirm: '确认',
                select_Network: '選擇網絡',
            },
            es_ES: {
                bind_inviter: 'vincular invitación',
                Please_enter_the_invitation_code: 'Por favor introduce el código de invitación.',
                confirm: 'Confirmar',
                select_Network: 'Seleccionar red',
            },
            tr_TR: {
                bind_inviter: 'Daveti bağla',
                Please_enter_the_invitation_code: 'Lütfen davet kodunu girin',
                confirm: 'Onaylamak',
                select_Network: 'Ağ seçin',
            },
            en_XA: {
                bind_inviter: 'ربط الدعوة',
                Please_enter_the_invitation_code: 'الرجاء إدخال رمز الدعوة',
                confirm: 'يتأكد',
                select_Network: 'حدد الشبكة',
            },
            pt_PT: {
                bind_inviter: 'Vincular convite',
                Please_enter_the_invitation_code: 'Por favor insira o código do convite',
                confirm: 'confirme',
                select_Network: 'Selecione a rede',
            },
            de_DE: {
                bind_inviter: 'Einladung binden',
                Please_enter_the_invitation_code: 'Bitte geben Sie den Einladungscode ein',
                confirm: 'Bestätigen',
                select_Network: 'Netzwerk auswählen',
            },
            fr_FR: {
                bind_inviter: 'Bind inviter',
                Please_enter_the_invitation_code: 'Veuillez entrer le code d\'invitation',
                confirm: 'Confirmer',
                select_Network: 'Sélectionner un réseau',
            },
            ja_JP: {
                bind_inviter: '招待をバインドする',
                Please_enter_the_invitation_code: '招待コードを入力してください',
                confirm: '確認する',
                select_Network: 'ネットワークを選択',
            },
            ko_KR: {
                bind_inviter: '초대자 바인딩',
                Please_enter_the_invitation_code: '초대코드를 입력해주세요',
                confirm: '확인하다',
                select_Network: '네트워크 선택',
            },
            it: {
                bind_inviter: 'Vincola l\'invitante',
                Please_enter_the_invitation_code: 'Inserisci il codice di invito',
                confirm: 'Confermare',
                select_Network: 'Seleziona la rete',
            },
            ru: {
                bind_inviter: 'Привязать приглашающего',
                Please_enter_the_invitation_code: 'Пожалуйста, введите код приглашения',
                confirm: 'Подтверждать',
                select_Network: 'Выберите сеть',
            },
        },
        silentTranslationWarn: false, // 是否关闭翻译报错; 
      }
  }).$mount();

  document.body.appendChild(instance.$el);

  Vue.nextTick(() => {
    instance.open(code, addr, base58Addr);
  });
};

export default register; // 导出
